/**
 * MediaUnitTagsAssignmentSchema — request payload for PUT-replace tag assignment.
 *
 * Hand-rolled Zod schema (NOT drizzle-zod derived) because this is a request
 * payload shape, not a select/insert table schema.
 *
 * Traceability: REQ-2.22
 */
import { z } from 'zod';

export const MediaUnitTagsAssignmentSchema = z.object({
  tagDefinitionIds: z.array(z.number().int().positive()).max(50),
});
export type MediaUnitTagsAssignment = z.infer<typeof MediaUnitTagsAssignmentSchema>;
